export const getAppDownloadLink = (options?: {
  utm_source?: string
  utm_campaign?: string

}) => {  
  const route = useRoute()
  
  const utm = [
    ...(options?.utm_source ?? route.query.utm_source ? [ `utm_source=${options?.utm_source ?? route.query.utm_source}` ] : []),
    ...(options?.utm_campaign ?? route.query.utm_campaign ? [ `utm_campaign=${options?.utm_campaign ?? route.query.utm_campaign}` ] : []),
  ]

  let string = (utm.length > 0 ? `${utm.join('&')}` : '')
  if (string.length > 0) string += `&referrer=${encodeURIComponent(string)}`

  return {
    auto: (/Mac|iPhone|iPad|iPod/i.test(navigator.userAgent) ? `https://apps.apple.com/fr/app/vibes-lgbt-rencontre-sors/id6463439764?` : `https://play.google.com/store/apps/details?id=lgbt.vibes.app&`) + string,
    
    ios: 'https://apps.apple.com/fr/app/vibes-lgbt-rencontre-sors/id6463439764' + (utm.length > 0 ? `?${string}` : ''),

    android: 'https://play.google.com/store/apps/details?id=lgbt.vibes.app' + (utm.length > 0 ? `&${string}` : '')
  } 
}